import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import QRCode from "qrcode-js";
import qrcode from "qrcode";
import { v4 as uuidv4 } from "uuid";
import JsBarcode from "jsbarcode";
import { generateEAN13, generateItemReference } from "../../../../utils/ean13Generator";

function ListadoArticulos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_ARTICULOS = import.meta.env.VITE_URL_ARTICULOS;
  const URL_LINEAS = import.meta.env.VITE_URL_LINEAS;
  const URL_MARCAS = import.meta.env.VITE_URL_MARCAS;
  const URL_FAMILIAS = import.meta.env.VITE_URL_FAMILIAS;
  const URL_COLECCIONES = import.meta.env.VITE_URL_COLECCIONES;
  const URL_PROVEEDORES = import.meta.env.VITE_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_PROPORCION =
    import.meta.env.VITE_URL_ARTICULOS_PROPORCION;
  const URL_COLORES = import.meta.env.VITE_URL_COLORES;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;

  const [articulos, setArticulos] = useState("");
  const [activo, setActivo] = useState("");
  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [piezasPorCaja, setPiezasPorCaja] = useState("");
  const [costoUSD, setCostoUSD] = useState("");
  const [costoMX, setCostoMX] = useState("");
  const [utilidadP, SetUtilidadP] = useState();
  const [utilidadM, setUtilidadM] = useState();
  const [lista1, setLista1] = useState("");
  const [lista2, setLista2] = useState("");
  const [lista3, setLista3] = useState("");
  const [lista4, setLista4] = useState("");
  const [venta, setVenta] = useState("");
  const [codigoSAT, setCodigoSAT] = useState("");
  const [codigoUnidad, setCodigoUnidad] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [colecciones, setColecciones] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [ano, setAno] = useState("");
  const [EAN, setEAN] = useState("");
  const [RFID, setRFID] = useState("");
  const [selectedCodigo, setSelectedCodigo] = useState(0);
  const [selectedNombre, setSelectedNombre] = useState(0);
  const [selectedLinea, setSelectedLinea] = useState(0);
  const [selectedMarca, setSelectedMarca] = useState(0);
  const [selectedFamilia, setSelectedFamilia] = useState(0);
  const [selectedColeccion, setSelectedColeccion] = useState(0);
  const [selectedProveedor, setSelectedProveedor] = useState(0);
  const [selectedAno, setSelectedAno] = useState(0);
  const [precioEsp, setPrecioEsp] = useState("");

  const [selectedLineaEdit, setSelectedLineaEdit] = useState("");
  const [selectedMarcaEdit, setSelectedMarcaEdit] = useState("");
  const [selectedFamiliaEdit, setSelectedFamiliaEdit] = useState("");
  const [selectedColeccionEdit, setSelectedColeccionEdit] = useState("");
  const [selectedProveedorEdit, setSelectedProveedorEdit] = useState("");
  const [idEditArticulo, setIdEditArticulo] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalProporcion, setModalProporcion] = useState(false);
  const toggleProporcion = () => setModalProporcion(!modalProporcion);
  const [amounts, setAmounts] = useState([]);
  const [arrayColores, setArrayColores] = useState([]);
  const [arrayColoresNew, setArrayColoresNew] = useState([]);
  const [arrayTallasNew, setArrayTallasNew] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(40), (val, index) => index + year);

  const [arrayTallas, setArrayTallas] = useState([]);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [selectedColor, setSelectedColor] = useState("");
  const [selectedTalla, setSelectedTalla] = useState("");

  const [inputFields, setInputFields] = useState([]);

  const [file, setFile] = useState(null);
  const [photo, setPhoto] = useState();
  const [photoUrl, setPhotoUrl] = useState("");
  const URL_FILEPOST = import.meta.env.VITE_URL_UPPROFILE;

  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);

  const [validaBoton, setValidaBoton] = useState(true);

  const [commentsTotal, setCommentsTotal] = useState([]);

  const [modalEditProporcionCodigos, setModalEditProporcionCodigos] =
    useState(false);
  const toggleEditProporcionCodigos = () =>
    setModalEditProporcionCodigos(!modalEditProporcionCodigos);
  const [proporcionCodigos, setProporcionCodigos] = useState([]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const [lastChanged, setLastChanged] = useState(null);

  const ITEMS_PER_PAGE = 50;

  // Single useEffect that handles both cases
  useEffect(() => {
    // Check which value changed and update accordingly
    if (lastChanged === "utilidadP") {
      // Calculate based on utilidadP
      const newUtilidadM = parseFloat(costoMX) * (utilidadP / 100);
      setUtilidadM(newUtilidadM);

      // Calculate venta price
      const newVenta = parseFloat(costoMX) + newUtilidadM;
      setVenta(newVenta.toFixed(2));
      setLista1(newVenta.toFixed(2));
      setLista2(newVenta.toFixed(2));
      setLista3(newVenta.toFixed(2));
      setLista4(newVenta.toFixed(2));
    } else if (lastChanged === "utilidadM") {
      // Calculate based on utilidadM
      const newUtilidadP = ((utilidadM / costoMX) * 100).toFixed(2);
      SetUtilidadP(newUtilidadP);

      // Calculate venta price
      const newVenta = parseFloat(costoMX) + utilidadM;
      setVenta(newVenta.toFixed(2));
      setLista1(newVenta.toFixed(2));
      setLista2(newVenta.toFixed(2));
      setLista3(newVenta.toFixed(2));
      setLista4(newVenta.toFixed(2));
    }
  }, [costoMX, utilidadP, utilidadM, lastChanged]);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        // Array para pagination
        let arrayTabla = allArticulos
          .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              activo: a.is_active,
              codigo: a.codigo,
              nombre: a.nombre,
              piezasPorCaja: a.piezasPorCaja,
              costoUSD: a.costoUSD,
              costoMX: a.costoMX,
              venta: a.venta,
              utilidadP: a.utilidadP,
              utilidadM: a.utilidadM,
              lista1: a.lista1,
              lista2: a.lista2,
              lista3: a.lista3,
              lista4: a.lista4,
              observaciones: a.observaciones,
              linea: a.lineas[0].name,
              marca: a.marcas[0].name,
              familia: a.familias[0].name,
              coleccion: a.colecciones[0].name,
              proveedor: a.proveedores[0].nombre_comercial,
              idLinea: a.lineas[0]._id,
              idMarca: a.marcas[0]._id,
              idFamilia: a.familias[0]._id,
              idColeccion: a.colecciones[0]._id,
              idProveedor: a.proveedores[0]._id,
              ano: a.ano,
              EAN: a.EAN,
              precioEsp: a.precioEsp,
              colores: a.colores,
              tallas: a.tallas,
              codigoSAT: a.codigoSAT,
              codigoUnidad: a.codigoUnidad,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setArticulos(allArticulos);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allLineas = res.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allMarcas = res.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_FAMILIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allFamilias = res.data;
        setFamilias(allFamilias);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColecciones = res.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);

        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);



  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedLinea === 0 || selectedLinea === a.idLinea) &&
        (selectedMarca === 0 || selectedMarca === a.idMarca) &&
        (selectedFamilia === 0 || selectedFamilia === a.idFamilia) &&
        (selectedColeccion === 0 || selectedColeccion === a.idColeccion) &&
        (selectedProveedor === 0 || selectedProveedor === a.idProveedor) &&
        (selectedAno === 0 || selectedAno === a.ano) &&
        (activo === 0 || activo === a.is_active)
      ) {
        return [
          a.codigo,
          a.nombre,
          a.piezasPorCaja,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.costoUSD),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.costoMX),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.venta),
          a.linea,
          a.marca,
          a.familia,
          a.coleccion,
          a.proveedor,
          a.ano,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Modelos`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Pzas x Caja",
          "FOB USD",
          "Costo MX",
          "Venta",
          "Linea",
          "Marca",
          "Familia",
          "Coleccion",
          "Proveedor",
          "Año",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedLinea === 0 || selectedLinea === a.idLinea) &&
        (selectedMarca === 0 || selectedMarca === a.idMarca) &&
        (selectedFamilia === 0 || selectedFamilia === a.idFamilia) &&
        (selectedColeccion === 0 || selectedColeccion === a.idColeccion) &&
        (selectedProveedor === 0 || selectedProveedor === a.idProveedor) &&
        (selectedAno === 0 || selectedAno === a.ano) &&
        a.activo === "Si"
      ) {
        return {
          ID: a._id,
          EAN:a.EAN,
          Codigo: a.codigo,
          Nombre: a.nombre,
          PiezasPorCaja: a.piezasPorCaja,
          FOBUSD: a.costoUSD,
          CostoMX: a.costoMX,
          Venta: a.venta,
          Linea: a.linea,
          Marca: a.marca,
          Familia: a.familia,
          Coleccion: a.coleccion,
          Proveedor: a.proveedor,
          Año: a.ano,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoModelos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoModelos",
        sheetFilter: [
          "ID",
          "EAN",
          "Codigo",
          "Nombre",
          "PiezasPorCaja",
          "FOBUSD",
          "CostoMX",
          "Venta",
          "Linea",
          "Marca",
          "Familia",
          "Coleccion",
          "Proveedor",
          "Año",
        ],
        sheetHeader: [
          "ID",
          "EAN",
          "Codigo",
          "Nombre",
          "PiezasPorCaja",
          "FOBUSD",
          "CostoMX",
          "Venta",
          "Linea",
          "Marca",
          "Familia",
          "Coleccion",
          "Proveedor",
          "Año",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedLinea === 0 || selectedLinea === a.idLinea) &&
        (selectedMarca === 0 || selectedMarca === a.idMarca) &&
        (selectedFamilia === 0 || selectedFamilia === a.idFamilia) &&
        (selectedColeccion === 0 || selectedColeccion === a.idColeccion) &&
        (selectedProveedor === 0 || selectedProveedor === a.idProveedor) &&
        (selectedAno === 0 || selectedAno === a.ano) &&
        (activo === 0 || activo === a.is_active)
      ) {
        return [
          a.codigo,
          a.nombre,
          a.piezasPorCaja,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.costoUSD),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.costoMX),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.venta),
          a.linea,
          a.marca,
          a.familia,
          a.coleccion,
          a.proveedor,
          a.ano,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Modelos`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Pzas x Caja",
          "FOB USD",
          "Costo MX",
          "Venta",
          "Linea",
          "Marca",
          "Familia",
          "Coleccion",
          "Proveedor",
          "Año",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Modelos",
          email: mailTo,
          fileName: "ListadoModelos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Modelos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  function jalaFoto(idEdit) {
    setPhoto("");
    setPhotoUrl("");
    const URL_GET_MEDIA = `${import.meta.env.VITE_URL_GETMEDIA}/${idEdit}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
        if (data.data.secure_url) {
          setPhotoUrl(data.data.secure_url);
        }
      })
      .catch((err) => console.log(err));

    setIdEditArticulo(idEdit);
    toggleFoto();
  }

  function jalaInfo(
    codigo,
    nombre,
    piezasPorCaja,
    costoUSD,
    costoMX,
    venta,
    utilidadP,
    utilidadM,
    lista1,
    lista2,
    lista3,
    lista4,
    observaciones,
    idLinea,
    idMarca,
    idFamilia,
    idColeccion,
    idProveedor,
    ano,
    EAN,
    RFID,
    precioEsp,
    codigoSAT,
    codigoUnidad,
    idEdit
  ) {
    setCodigo(codigo);
    setNombre(nombre);
    setPiezasPorCaja(piezasPorCaja);
    setCostoUSD(costoUSD);
    setCostoMX(costoMX);
    setVenta(venta);
    SetUtilidadP(utilidadP);
    setUtilidadM(utilidadM);
    setLista1(lista1);
    setLista2(lista2);
    setLista3(lista3);
    setLista4(lista4);
    setObservaciones(observaciones);
    setSelectedLineaEdit(idLinea);
    setSelectedMarcaEdit(idMarca);
    setSelectedFamiliaEdit(idFamilia);
    setSelectedColeccionEdit(idColeccion);
    setSelectedProveedorEdit(idProveedor);
    setAno(ano);
    setEAN(EAN);
    setRFID(RFID || "");
    setPrecioEsp(precioEsp);
    setIdEditArticulo(idEdit);
    setCodigoSAT(codigoSAT);
    setCodigoUnidad(codigoUnidad);
    setProporcionCodigos([]);
    toggleEdit();
  }

  function editArticulos(event) {
    event.preventDefault();
    const URL_ARTICULOS_EDIT = `${import.meta.env.VITE_URL_ARTICULOS}/${idEditArticulo}`;
    if (file == null) {
      axios
        .patch(
          URL_ARTICULOS_EDIT,
          {
            codigo,
            nombre,
            piezasPorCaja,
            costoUSD,
            costoMX,
            utilidadP,
            utilidadM,
            lista1,
            lista2,
            lista3,
            lista4,
            venta,
            lineas: selectedLineaEdit,
            marcas: selectedMarcaEdit,
            familias: selectedFamiliaEdit,
            colecciones: selectedColeccionEdit,
            proveedores: selectedProveedorEdit,
            ano,
            EAN,
            precioEsp,
            codigoSAT,
            codigoUnidad,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          axios.post(
            URL_LOGS,
            {
              tipo: "Editar Articulo",
              detalle: `${nombre} ${codigo}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          toggleEdit();
          Swal.fire("Good job!", "Actualizado con exito", "success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
          });
          console.log(error);
        });
    } else {
      axios
        .patch(
          URL_ARTICULOS_EDIT,
          {
            codigo,
            nombre,
            piezasPorCaja,
            costoUSD,
            costoMX,
            venta,
            utilidadP,
            utilidadM,
            lista1,
            lista2,
            lista3,
            lista4,
            lineas: selectedLineaEdit,
            marcas: selectedMarcaEdit,
            familias: selectedFamiliaEdit,
            colecciones: selectedColeccionEdit,
            proveedores: selectedProveedorEdit,
            ano,
            EAN,
            precioEsp,
            codigoSAT,
            codigoUnidad,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("articulo", idEditArticulo);

          axios
            .post(URL_FILEPOST, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then(() => {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Articulo",
                  detalle: `${nombre} ${codigo}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );

              toggleEdit();
              Swal.fire("Good job!", "Actualizado con exito", "success");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
        });
    }
  }
  const headers = [
    { name: "Activo", field: "activo", sortable: true },
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Pzas Caja", field: "piezasPorCaja", sortable: true },
    // { name: "FOB USD", field: "costoUSD", sortable: true },
    // { name: "Costo MX", field: "costoMX", sortable: true },
    { name: "Venta", field: "venta", sortable: true },
    { name: "Familia", field: "familia", sortable: true },
    { name: "Linea", field: "linea", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    { name: "Coleccion", field: "coleccion", sortable: true },
    { name: "Proveedor", field: "proveedor", sortable: true },
    { name: "Año", field: "ano", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment._id.toLowerCase().includes(search.toLowerCase()) ||
          comment.codigo.toLowerCase().includes(search.toLowerCase()) ||
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.linea.toLowerCase().includes(search.toLowerCase()) ||
          comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          comment.familia.toLowerCase().includes(search.toLowerCase()) ||
          comment.coleccion.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.codigoSAT.toLowerCase().includes(search.toLowerCase()) ||
          comment.codigoUnidad.toLowerCase().includes(search.toLowerCase()) ||
          comment.piezasPorCaja.toString().includes(search) ||
          comment.costoUSD.toString().includes(search) ||
          comment.costoMX.toString().includes(search) ||
          comment.venta.toString().includes(search) ||
          comment.ano.toString().includes(search)
      );
    }
    if (selectedCodigo) {
      computedComments = computedComments.filter((e) =>
        e._id.includes(selectedCodigo)
      );
    }
    if (selectedNombre) {
      computedComments = computedComments.filter((e) =>
        e._id.includes(selectedNombre)
      );
    }
    if (selectedLinea) {
      computedComments = computedComments.filter((e) =>
        e.idLinea.includes(selectedLinea)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarca.includes(selectedMarca)
      );
    }
    if (selectedFamilia) {
      computedComments = computedComments.filter((e) =>
        e.idFamilia.includes(selectedFamilia)
      );
    }
    if (selectedColeccion) {
      computedComments = computedComments.filter((e) =>
        e.idColeccion.includes(selectedColeccion)
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedor.includes(selectedProveedor)
      );
    }
    if (selectedAno) {
      computedComments = computedComments.filter((e) =>
        e.ano.includes(selectedAno)
      );
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "piezasPorCaja" &&
      sorting.field != "costoUSD" &&
      sorting.field != "costoMX" &&
      sorting.field != "venta"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field === "piezasPorCaja" ||
        sorting.field === "costoUSD" ||
        sorting.field === "costoMX" ||
        sorting.field === "venta")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field === "piezasPorCaja" ||
        sorting.field === "costoUSD" ||
        sorting.field === "costoMX" ||
        sorting.field === "venta")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    setCommentsTotal(computedComments);
    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCodigo,
    selectedNombre,
    selectedLinea,
    selectedMarca,
    selectedFamilia,
    selectedColeccion,
    selectedProveedor,
    selectedAno,
    activo,
  ]);

  // Cambia el import al inicio del archivo:
  // import qrcode from "qrcode-js";
  // Por:

  async function QRGen(
    idArt,
    codigo,
    nombre,
    piezasPorCaja,
    linea,
    marca,
    familia,
    coleccion,
    ano,
    composicion,
    venta
  ) {
    await axios
      .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idArt}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async (res) => {
        const allPorporcion = res.data.filter(
          (porcion) => porcion.cantidad !== "0"
        );

        // Changed to 46mm x 20mm format with high quality settings
        const doc = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: [46, 20],
          compress: false, // Disable compression for better quality
          precision: 16, // Higher precision for better rendering
        });

        const tallas = Array.from(
          new Set(
            allPorporcion.flatMap((porcion) =>
              porcion.tallas.map((talla) => talla.name)
            )
          )
        );

        const sortedTallas = tallas;

        // Define columns (tallas)
        const columns = ["", ...sortedTallas];

        // Group data by color
        const groupedData = {};
        allPorporcion.forEach((porcion) => {
          const colorName = porcion.colores[0].name;
          if (!groupedData[colorName]) {
            groupedData[colorName] = {};
            // Store the proportion ID for each color
            groupedData[colorName].id = porcion._id;
          }
          groupedData[colorName][porcion.tallas[0].name] =
            porcion.cantidad || 0;
        });

        // Define rows (colores, cantidad) - sort colors alphabetically
        const rows = Object.keys(groupedData)
          .sort((a, b) => a.localeCompare(b)) // Sort colors alphabetically
          .map((colorName) => {
            const rowData = [colorName];
            sortedTallas.forEach((talla) => {
              rowData.push(groupedData[colorName][talla] || 0);
            });
            return rowData;
          });

        // Smart pagination for summary table - handles many colors and sizes
        const maxRowsPerPage = 6; // Maximum rows that fit in 20mm height
        const maxColsPerPage = 8; // Maximum columns that fit in 46mm width

        const colorNames = Object.keys(groupedData).sort((a, b) =>
          a.localeCompare(b)
        );
        const totalColors = colorNames.length;
        const totalSizes = sortedTallas.length;

        // Calculate how many pages we need for columns (sizes)
        const sizePages = Math.ceil(totalSizes / maxColsPerPage);

        // Create summary pages
        for (let sizePage = 0; sizePage < sizePages; sizePage++) {
          const startSizeIndex = sizePage * maxColsPerPage;
          const endSizeIndex = Math.min(
            startSizeIndex + maxColsPerPage,
            totalSizes
          );
          const currentSizes = sortedTallas.slice(startSizeIndex, endSizeIndex);

          // Calculate how many pages we need for rows (colors) for this size range
          const colorPages = Math.ceil(totalColors / maxRowsPerPage);

          for (let colorPage = 0; colorPage < colorPages; colorPage++) {
            const startColorIndex = colorPage * maxRowsPerPage;
            const endColorIndex = Math.min(
              startColorIndex + maxRowsPerPage,
              totalColors
            );
            const currentColors = colorNames.slice(
              startColorIndex,
              endColorIndex
            );

            // Add page (except for the very first one)
            if (sizePage > 0 || colorPage > 0) {
              doc.addPage();
            }

            // Page header
            doc.setFontSize(4).setFont(undefined, "bold");
            doc.text(`MODELO: ${codigo}`, 1, 3);
            doc.setFontSize(3);
            doc.text(`Piezas X Caja: ${piezasPorCaja}`, 22, 3);

            // Page info if multiple pages
            if (sizePages > 1 || colorPages > 1) {
              doc.setFontSize(2);
              doc.text(
                `Pág ${colorPage + 1 + sizePage * colorPages}/${colorPages * sizePages
                }`,
                40,
                3
              );
            }

            // Create custom table with text positioning
            let yPos = 5;
            const colWidth = Math.min(4, 40 / currentSizes.length); // Adjust column width based on number of sizes
            const colorColWidth = 8;

            // Table header
            doc.setFontSize(2.5).setFont(undefined, "bold");
            doc.text("COLOR", 1, yPos);
            let xPos = colorColWidth + 1;
            currentSizes.forEach((talla) => {
              doc.text(talla, xPos, yPos);
              xPos += colWidth;
            });

            yPos += 2;

            // Table rows for current color range
            doc.setFontSize(2).setFont(undefined, "normal");
            currentColors.forEach((colorName) => {
              // Truncate color name if too long
              const shortColor =
                colorName.length > 6 ? colorName.substring(0, 6) : colorName;
              doc.text(shortColor, 1, yPos);

              xPos = colorColWidth + 1;
              currentSizes.forEach((talla) => {
                const qty = groupedData[colorName][talla] || 0;
                doc.text(qty.toString(), xPos, yPos);
                xPos += colWidth;
              });
              yPos += 2;
            });
          }
        }

        // Sort proportions first by color alphabetically, then by size using custom order
        const sortedProportions = [...allPorporcion].sort((a, b) => {
          // First sort by color name
          const colorCompare = a.colores[0].name.localeCompare(
            b.colores[0].name
          );
          if (colorCompare !== 0) return colorCompare;

          // Then sort by size according to custom order
          const aIndex = customSizeOrder.indexOf(a.tallas[0].name);
          const bIndex = customSizeOrder.indexOf(b.tallas[0].name);
          return aIndex - bIndex;
        });

        // Generate RFID label (35x65mm) for each proportion
        for (const porcion of sortedProportions) {
          const colorNombre = porcion.colores[0].name;
          const colorPrefijo = porcion.colores[0].prefijo || "";
          const tallaNombre = porcion.tallas[0].name;
          const ean = `${codigo}${colorPrefijo}${tallaNombre}`;
          const rfid = porcion.RFID || generateEAN13(generateItemReference(codigo, colorNombre, tallaNombre));

          doc.addPage([35, 65], "portrait");
          const lw = 35;
          let y = 2;

          // RFID label
          doc.setFontSize(6).setFont(undefined, "normal");
          const rfidLabel = "RFID";
          doc.text(rfidLabel, (lw - doc.getTextWidth(rfidLabel)) / 2, y + 3);
          y += 6;

          // SIZE + STYLE
          doc.setFontSize(7).setFont(undefined, "bold");
          doc.text(`SIZE: ${tallaNombre}`, 2, y);
          y += 3.5;
          doc.text(`STYLE: ${codigo}`, 2, y);
          y += 4;

          // Code 128 barcode (EAN)
          try {
            const c128 = document.createElement("canvas");
            JsBarcode(c128, ean, { format: "CODE128", width: 2, height: 50, displayValue: false, margin: 0, background: "#FFFFFF", lineColor: "#000000" });
            doc.addImage(c128.toDataURL("image/png", 1.0), "PNG", 2, y, 31, 10);
            y += 11;
          } catch (e) { y += 11; }

          // QR Code
          try {
            const qrDataUrl = await qrcode.toDataURL(ean);
            const qrSize = 16;
            doc.addImage(qrDataUrl, "PNG", (lw - qrSize) / 2, y, qrSize, qrSize);
            y += qrSize + 1;
            doc.setFontSize(6).setFont(undefined, "bold");
            const skuW = doc.getTextWidth(ean);
            doc.text(ean, (lw - skuW) / 2, y);
            y += 4;
          } catch (e) { y += 20; }

          // EAN-13 barcode (RFID)
          try {
            const ean13 = document.createElement("canvas");
            JsBarcode(ean13, rfid, { format: "EAN13", width: 2, height: 50, displayValue: false, margin: 0, background: "#FFFFFF", lineColor: "#000000" });
            doc.addImage(ean13.toDataURL("image/png", 1.0), "PNG", 2, y, 31, 10);
            y += 11;
            doc.setFontSize(6).setFont(undefined, "normal");
            const rfidW = doc.getTextWidth(rfid);
            doc.text(rfid, (lw - rfidW) / 2, y);
          } catch (e) {}
        }

        // Generate high-quality PDF output
        const pdfOutput = doc.output("blob", {
          compress: false, // Ensure no compression is applied to final output
        });
        const url = URL.createObjectURL(pdfOutput);
        window.open(url, "_blank");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function QRGenSingle(
    idArt,
    codigo,
    nombre,
    piezasPorCaja,
    linea,
    marca,
    familia,
    coleccion,
    ano,
    composicion,
    venta
  ) {
    try {
      const response = await axios.get(
        `${URL_ARTICULOS_PROPORCION}Articulos/${idArt}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      const allPorporcion = response.data.filter(
        (porcion) => porcion.cantidad !== "0"
      );


      // Create new PDF document
      const doc = new jsPDF("landscape", "mm", [100, 60], true);

      // Get unique tallas
      const tallas = Array.from(
        new Set(
          allPorporcion.flatMap((porcion) =>
            porcion.tallas.map((talla) => talla.name)
          )
        )
      );

      // Sort tallas according to custom order
      const sortedTallas = tallas;

      // Define columns
      const columns = ["", ...sortedTallas];

      // Group data by color
      const groupedData = {};
      allPorporcion.forEach((porcion) => {
        const colorName = porcion.colores[0].name;
        if (!groupedData[colorName]) {
          groupedData[colorName] = {};
        }
        groupedData[colorName][porcion.tallas[0].name] = porcion.cantidad || 0;
      });

      // Create rows from grouped data
      const rows = Object.keys(groupedData).map((colorName) => {
        const rowData = [colorName];
        tallas.forEach((talla) => {
          rowData.push(groupedData[colorName][talla] || 0);
        });
        return rowData;
      });

      // Generate first page with table
      doc.setFontSize(8).setFont(undefined, "bold");
      doc.text(`MODELO: ${codigo}`, 5, 5);
      doc.setFontSize(6);
      doc.text(`Piezas X Caja: ${piezasPorCaja}`, 45, 5);

      doc.autoTable({
        head: [columns],
        body: rows,
        startY: 7,
        margin: { left: 0.5, right: 0.5 },
        headStyles: {
          fillColor: false,
          textColor: [0, 0, 0],
          fontStyle: "bold",
          lineWidth: 0,
        },
        styles: {
          fontStyle: "bold",
          fontSize: 5,
          cellPadding: 0.7,
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
          textColor: [0, 0, 0],
        },
      });

      // Generate RFID label (35x65mm) for each proportion
      for (const porcion of allPorporcion) {
        const colorNombre = porcion.colores[0].name;
        const colorPrefijo = porcion.colores[0].prefijo || "";
        const tallaNombre = porcion.tallas[0].name;
        const eanCode = `${codigo}${colorPrefijo}${tallaNombre}`;
        const rfid = porcion.RFID || generateEAN13(generateItemReference(codigo, colorNombre, tallaNombre));

        doc.addPage([35, 65], "portrait");
        const lw = 35;
        let y = 2;

        doc.setFontSize(6).setFont(undefined, "normal");
        const rfidLabel = "RFID";
        doc.text(rfidLabel, (lw - doc.getTextWidth(rfidLabel)) / 2, y + 3);
        y += 6;

        doc.setFontSize(7).setFont(undefined, "bold");
        doc.text(`SIZE: ${tallaNombre}`, 2, y);
        y += 3.5;
        doc.text(`STYLE: ${codigo}`, 2, y);
        y += 4;

        try {
          const c128 = document.createElement("canvas");
          JsBarcode(c128, eanCode, { format: "CODE128", width: 2, height: 50, displayValue: false, margin: 0, background: "#FFFFFF", lineColor: "#000000" });
          doc.addImage(c128.toDataURL("image/png", 1.0), "PNG", 2, y, 31, 10);
          y += 11;
        } catch (e) { y += 11; }

        try {
          const qrDataUrl = await qrcode.toDataURL(eanCode);
          const qrSize = 16;
          doc.addImage(qrDataUrl, "PNG", (lw - qrSize) / 2, y, qrSize, qrSize);
          y += qrSize + 1;
          doc.setFontSize(6).setFont(undefined, "bold");
          const skuW = doc.getTextWidth(eanCode);
          doc.text(eanCode, (lw - skuW) / 2, y);
          y += 4;
        } catch (e) { y += 20; }

        try {
          const ean13 = document.createElement("canvas");
          JsBarcode(ean13, rfid, { format: "EAN13", width: 2, height: 50, displayValue: false, margin: 0, background: "#FFFFFF", lineColor: "#000000" });
          doc.addImage(ean13.toDataURL("image/png", 1.0), "PNG", 2, y, 31, 10);
          y += 11;
          doc.setFontSize(6).setFont(undefined, "normal");
          const rfidW = doc.getTextWidth(rfid);
          doc.text(rfid, (lw - rfidW) / 2, y);
        } catch (e) {}
      }

      window.open(doc.output("bloburl"), "_blank");
    } catch (error) {
      console.error("Error generating QR codes:", error);
      throw error;
    }
  }

  // Updated jalaProporcion function with unified approach
  function jalaProporcion(idEdit, codigo, nombre, tallas) {
    setIdEditArticulo(idEdit);
    setCodigo(codigo);
    setNombre(nombre);

    // Load proportion data (single call, not Promise.all since we're unifying)
    axios.get(`${URL_ARTICULOS_PROPORCION}Articulos/${idEdit}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
      .then((response) => {
        const allProporcion = response.data;

        // Create unified amounts array with BOTH quantities and barcodes
        let arrayTabla = allProporcion
          .map((i) => {
            return {
              _id: i._id,
              size: i.tallas[0].name,
              sizeId: i.tallas[0]._id,
              color: i.colores[0].name,
              colorId: i.colores[0]._id,
              amount: parseInt(i.cantidad) || 0, // Include all amounts, even 0
              EAN: i.EAN || "", // Include EAN in the same object
              isNew: false // Mark as existing entries
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        // Set unique colors
        let uniqueColors = {};
        let arrayTablaColores = allProporcion
          .map((i) => {
            return {
              name: i.colores[0].name,
              id: i.colores[0]._id,
            };
          })
          .filter(function (el) {
            if (el && !uniqueColors[el.id]) {
              uniqueColors[el.id] = true;
              return true;
            }
            return false;
          });

        let dataFinalColores = Object.values(arrayTablaColores);
        setArrayColores(dataFinalColores);

        // Set unique sizes
        let uniqueTallas = {};
        let arrayTablaTallas = allProporcion
          .map((i) => {
            return {
              name: i.tallas[0].name,
              id: i.tallas[0]._id,
            };
          })
          .filter(function (el) {
            if (el && !uniqueTallas[el.id]) {
              uniqueTallas[el.id] = true;
              return true;
            }
            return false;
          });

        let dataFinalTallas = Object.values(arrayTablaTallas);
        let arrayFinalTallas = dataFinalTallas.sort((a, b) => {
          return tallas.indexOf(a.name) - tallas.indexOf(b.name);
        });

        setArrayTallas(arrayFinalTallas);

        function customSort(a, b) {
          // First, compare colors
          const colorComparison = a.color.localeCompare(b.color);

          // If colors are the same, compare sizes
          if (colorComparison === 0) {
            const sizeOrder = {
              CH: 0, M: 1, G: 2, EG: 3, "2EG": 4, "3EG": 5, "4EG": 6, "5EG": 7, "6EG": 8,
              1: 9, 2: 10, 3: 11, 4: 12, 5: 13, 6: 14, 7: 15, 8: 16, 9: 17, 10: 18,
              11: 19, 12: 20, 13: 21, 14: 22, 15: 23, 16: 24, 17: 25, 18: 26, 19: 27,
              20: 28, 21: 29, 22: 30, 23: 31, 24: 32, 25: 33, 26: 34, 27: 35, 28: 36,
              29: 37, 30: 38, 31: 39, 32: 40, 33: 41, 34: 42, 35: 43, 36: 44, 37: 45,
              38: 46, 39: 47, 40: 23, 48: 23, 41: 49, 42: 50, 43: 51, 44: 52, 45: 53, 46: 54,
              47: 55, 48: 56, 49: 57, 50: 58, "5/6": 59, "7/8": 60, "10/12": 61, "14/16": 62,
            };

            return sizeOrder[a.size] - sizeOrder[b.size];
          }

          return colorComparison;
        }

        // Sort the unified array
        const sortedData = dataFinal.sort(customSort);
        setAmounts(sortedData); // Now contains both quantities and EAN codes

        // Clear separate barcode array - no longer needed
        setProporcionCodigos([]);

        // Clear any existing new entries
        setInputFields([]);
        setArrayColoresNew([]);
        setArrayTallasNew([]);

        toggleProporcion();
      })
      .catch((err) => console.log(err));
  }

  // Updated getEntryValue function
  const getEntryValue = (colorId, sizeId, field) => {
    // First check amounts (existing database entries)
    const existingEntry = amounts.find(
      (entry) => entry.colorId === colorId && entry.sizeId === sizeId
    );

    if (existingEntry) {
      return existingEntry[field] || (field === 'amount' ? 0 : "");
    }

    // Then check inputFields (new entries being created)
    const newEntry = inputFields.find(
      (entry) => entry.colorId === colorId && entry.sizeId === sizeId
    );

    if (newEntry) {
      return newEntry[field] || (field === 'amount' ? 0 : "");
    }

    // Return default value for virtual entries
    return field === 'amount' ? 0 : "";
  };

  // Unified input change handler
  const handleUnifiedInputChange = (sizeId, colorId, value, field = 'amount') => {
    // Check if entry exists in amounts (database entries)
    const existingInAmounts = amounts.find(
      (entry) => entry.sizeId === sizeId && entry.colorId === colorId
    );

    if (existingInAmounts) {
      // Update existing database entry
      const updatedAmounts = amounts.map(entry => {
        if (entry.sizeId === sizeId && entry.colorId === colorId) {
          return { ...entry, [field]: value };
        }
        return entry;
      });
      setAmounts(updatedAmounts);
    } else {
      // Handle as new entry in inputFields
      const updatedInputFields = [...inputFields];
      const existingInInputFields = updatedInputFields.findIndex(
        (entry) => entry.sizeId === sizeId && entry.colorId === colorId
      );

      if (existingInInputFields !== -1) {
        // Update existing entry in inputFields
        updatedInputFields[existingInInputFields][field] = value;
      } else {
        // Create new entry
        const newEntry = {
          id: uuidv4(),
          colorId: colorId,
          color: "",
          sizeId: sizeId,
          size: "",
          amount: field === 'amount' ? value : 0,
          EAN: field === 'EAN' ? value : "",
          isNew: true
        };
        updatedInputFields.push(newEntry);
      }
      setInputFields(updatedInputFields);
    }
  };


  // Updated handleInputChangeNew to be more consistent
  const handleInputChangeNew = (sizeId, colorId, value, field = 'amount') => {
    const updatedInputFields = [...inputFields];
    const existingEntryIndex = updatedInputFields.findIndex(
      (entry) => entry.sizeId === sizeId && entry.colorId === colorId
    );

    if (existingEntryIndex !== -1) {
      // Update existing entry
      updatedInputFields[existingEntryIndex][field] = value;
    } else {
      // Create new entry
      const newEntry = {
        id: uuidv4(),
        colorId: colorId,
        color: "",
        sizeId: sizeId,
        size: "",
        amount: field === 'amount' ? value : 0,
        EAN: field === 'EAN' ? value : "",
        isNew: true
      };
      updatedInputFields.push(newEntry);
    }

    setInputFields(updatedInputFields);
  };

  // Simplified and unified editProporcion function
  function editProporcion() {
    // Actualizar TODAS las celdas existentes, no solo las > 0: poner una
    // celda en 0 tambien debe guardarse, y asi la suma en BD queda igual a lo
    // que se ve en pantalla (antes una celda puesta en 0 conservaba su valor
    // viejo en BD sin avisar).
    const existingEntriesToUpdate = amounts;

    const newEntriesToCreate = inputFields.filter(entry =>
      entry.amount > 0 || (entry.EAN && entry.EAN.trim() !== "")
    );

    // piezasPorCaja del modelo = suma de la proporcion que se esta guardando.
    // Antes no se recalculaba y el modelo conservaba el valor viejo aunque se
    // corrigiera la proporcion (caso HSL5762FA: proporcion corregida pero
    // piezasPorCaja seguia en 11 y la entrada por cajas salia corta).
    const nuevoPiezasPorCaja = [...amounts, ...newEntriesToCreate].reduce(
      (t, e) => t + (parseFloat(e.amount) || 0),
      0
    );

    let totalOperations = existingEntriesToUpdate.length + newEntriesToCreate.length;
    let completedOperations = 0;
    // Antes cualquier peticion fallida solo hacia console.log y el modal
    // igual decia "Se actualizo correctamente": el usuario se iba creyendo
    // que guardo. Ahora las fallas se cuentan y se avisan.
    const fallas = [];

    const checkCompletion = () => {
      completedOperations++;
      if (completedOperations === totalOperations) {
        if (fallas.length > 0) {
          Swal.fire({
            icon: "error",
            title: "Se guardó incompleto",
            html: `No se pudieron guardar ${fallas.length} de ${totalOperations} cambios.<br/><small>${fallas.slice(0, 5).join("<br/>")}</small>`,
          });
          return;
        }
        Swal.fire({
          icon: "success",
          title: "Se actualizó correctamente",
          showConfirmButton: false,
          timer: 1500,
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    };

    const registraFalla = (etiqueta, err) => {
      console.log(err);
      fallas.push(`${etiqueta}: ${err?.response?.data?.message || err?.response?.data?.error || err.message}`);
    };

    // El EAN vacio se OMITE del cuerpo: el validador del backend rechaza
    // EAN = "" y tiraba la peticion completa (la cantidad se perdia en
    // silencio, solo quedaba un console.log).
    const bodyProporcion = (entry) => {
      const body = { cantidad: entry.amount || 0 };
      if (entry.EAN && entry.EAN.trim() !== "") body.EAN = entry.EAN;
      return body;
    };

    // Update existing entries (both quantity and EAN in single request)
    existingEntriesToUpdate.forEach((entry) => {
      axios
        .patch(
          `${URL_ARTICULOS_PROPORCION}/${entry._id}`,
          bodyProporcion(entry),
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          checkCompletion();
        })
        .catch((err) => {
          registraFalla(`${entry.color} ${entry.size}`, err);
          checkCompletion();
        });
    });

    // Create new entries (both quantity and EAN in single request)
    newEntriesToCreate.forEach((entry) => {
      axios
        .post(
          URL_ARTICULOS_PROPORCION,
          {
            ...bodyProporcion(entry),
            articulos: idEditArticulo,
            colores: entry.colorId,
            tallas: entry.sizeId,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          checkCompletion();
        })
        .catch((error) => {
          registraFalla(`${entry.color} ${entry.size} (nuevo)`, error);
          checkCompletion();
        });
    });

    // Guardar el piezasPorCaja recalculado como una operacion mas del lote
    // (dentro del contador, para que el reload espere a que termine). Este
    // bloque corre de forma sincrona antes de que resuelva cualquier axios,
    // asi que el contador queda listo antes del primer checkCompletion.
    if (totalOperations > 0) {
      totalOperations += 1;
      axios
        .patch(
          `${URL_ARTICULOS}/${idEditArticulo}`,
          { piezasPorCaja: nuevoPiezasPorCaja },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          checkCompletion();
        })
        .catch((err) => {
          registraFalla("piezasPorCaja", err);
          checkCompletion();
        });
    }

    // Los arreglos `colores`/`tallas` del modelo YA NO se mandan desde aqui.
    // Antes este PATCH: (1) solo corria si el color se habia agregado en esta
    // misma sesion del modal, asi que las proporciones que llegaban por otra
    // via dejaban el modelo corto; (2) se mandaba sin contarlo en
    // totalOperations, y el reload de 1s lo alcanzaba a abortar; (3) fallaba
    // en silencio. Resultado: colores que existian en la proporcion pero no en
    // el modelo — invisibles en Compras y en caja aunque hubiera inventario
    // (caso HSL5726BL / LIGHT KHAKI).
    // Ademas REEMPLAZABA el arreglo, asi que borraba cualquier color/talla del
    // modelo que no tuviera proporcion (podia dejar invendible mercancia de
    // otros flujos).
    // Ahora lo hace el backend en ArticulosProporcionController, con $addToSet
    // en el create/reuse Y en el edit de la proporcion: es aditivo, corre
    // siempre y cubre todos los flujos (modal, conversion de premodelo, etc.).
    // Para reparar los modelos que ya quedaron cortos:
    // node scripts/sincronizarColoresTallas.js

    // If no operations to perform
    if (totalOperations === 0) {
      Swal.fire({
        icon: "success",
        title: "No changes to save",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }

  // Updated addColor function
  const addColor = () => {
    if (selectedColor === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Selecciona un color!",
      });
      return;
    }

    let c = "";
    let foundColor = colores.find((a) => a._id === selectedColor);

    if (foundColor) {
      c = foundColor.name;
    }

    // Create entries for all existing sizes with the new color
    let add = arrayTallas.map((a) => ({
      id: uuidv4(),
      colorId: selectedColor,
      color: c,
      sizeId: a.id,
      size: a.name,
      amount: 0,
      EAN: "",
      isNew: true
    }));

    setInputFields([...inputFields, ...add]);

    let colNew = [...arrayColoresNew, { id: selectedColor, name: c }];
    setArrayColoresNew(colNew);
    let coloresUpdated = colores.filter((a) => a._id !== selectedColor);
    setColores(coloresUpdated);
  };

  // Updated addTalla function
  const addTalla = () => {
    if (selectedTalla === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Selecciona un Talla!",
      });
      return;
    }

    let c = "";
    let foundTalla = tallas.find((a) => a._id === selectedTalla);

    if (foundTalla) {
      c = foundTalla.name;
    }

    // Create entries for all existing colors with the new size
    let addForExistingColors = arrayColores.map((a) => ({
      id: uuidv4(),
      colorId: a.id,
      color: a.name,
      sizeId: selectedTalla,
      size: c,
      amount: 0,
      EAN: "",
      isNew: true
    }));

    // Create entries for new colors with the new size
    let addForNewColors = arrayColoresNew.map((a) => ({
      id: uuidv4(),
      colorId: a.id,
      color: a.name,
      sizeId: selectedTalla,
      size: c,
      amount: 0,
      EAN: "",
      isNew: true
    }));

    setInputFields([...inputFields, ...addForExistingColors, ...addForNewColors]);

    let colNew = [...arrayTallasNew, { id: selectedTalla, name: c }];
    setArrayTallasNew(colNew);
    let tallasUpdated = tallas.filter((a) => a._id !== selectedTalla);
    setTallas(tallasUpdated);
  };

  async function jalaCodigosColorTalla() {
    try {
      const res = await axios.get(
        `${URL_ARTICULOS_PROPORCION}Articulos/${idEditArticulo}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      const data = res.data;

      // Ordenamos
      data.sort((a, b) => {
        const colorA = a.colores[0]?.name || "";
        const colorB = b.colores[0]?.name || "";

        if (colorA < colorB) return -1;
        if (colorA > colorB) return 1;

        // Si el color es igual, ahora ordenamos por talla personalizada
        const tallaA = a.tallas[0]?.name || "";
        const tallaB = b.tallas[0]?.name || "";

        const indexA = customSizeOrder.indexOf(tallaA);
        const indexB = customSizeOrder.indexOf(tallaB);

        return indexA - indexB;
      });

      setProporcionCodigos(data);
      toggleEditProporcionCodigos();
    } catch (err) {
      console.log(err);
    }
  }

  async function handleCodigo(id, event) {
    // Make sure we have a valid ID before proceeding
    if (!id) return;

    const newInputFields = proporcionCodigos.map((i) => {
      if (id === i._id) {
        return { ...i, EAN: event };
      }
      return i;
    });
    setProporcionCodigos(newInputFields);
  }

  async function saveProporcionCodigos() {
    let total = proporcionCodigos.length;

    proporcionCodigos.map((a) => {
      axios
        .patch(
          `${URL_ARTICULOS_PROPORCION}/${a._id}`,
          {
            EAN: a.EAN,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((res) => {
          total = total - 1;
          if (total === 0) {
            Swal.fire({
              icon: "success",
              title: "Se actualizo correctamente",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.articulos_create ? (
                <>
                  <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    href="/ArticulosCreate"
                  >
                    Nuevo Modelo
                  </Button>
                </>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Modelo
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuArticulos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                {/* <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={QRGenMasivo}
                >
                  QR <i class="fas fa-qrcode"></i>
                </Button> */}
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Modelos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Modelos</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCodigo}
                  onChange={(e) => {
                    setSelectedCodigo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {comments
                    .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.codigo}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedNombre}
                  onChange={(e) => {
                    setSelectedNombre(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {comments
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.nombre}</option>;
                    })}
                </Input>
              </td>
              {/* <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td> */}
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedFamilia}
                  onChange={(e) => {
                    setSelectedFamilia(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {familias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedLinea}
                  onChange={(e) => {
                    setSelectedLinea(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedColeccion}
                  onChange={(e) => {
                    setSelectedColeccion(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {colecciones
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedProveedor}
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedAno}
                  onChange={(e) => {
                    setSelectedAno(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {years.map((a) => {
                    return <option value={a}>{a}</option>;
                  })}
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.activo}</td>
                      <td>{a.codigo}</td>
                      <td>{a.nombre}</td>
                      <td>{a.piezasPorCaja}</td>
                      {/* <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                            a.costoUSD
                          )}{" "}
                      </td> */}
                      {/* <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoMX)}{" "}
                      </td> */}
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.venta)}{" "}
                      </td>
                      <td>{a.familia} </td>
                      <td>{a.linea} </td>
                      <td>{a.marca} </td>
                      <td>{a.coleccion} </td>
                      <td>{a.proveedor} </td>
                      <td>{a.ano} </td>
                      <td>
                        {user.articulos_create ? (
                          <div>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => jalaFoto(a._id)}
                            >
                              <i class="fas fa-camera"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) =>
                                QRGenSingle(
                                  a._id,
                                  a.codigo,
                                  a.nombre,
                                  a.piezasPorCaja,
                                  a.linea,
                                  a.marca,
                                  a.familia,
                                  a.coleccion,
                                  a.ano,
                                  a.venta
                                )
                              }
                            >
                              <i class="fas fa-qrcode"></i>
                            </Button>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                QRGen(
                                  a._id,
                                  a.codigo,
                                  a.nombre,
                                  a.piezasPorCaja,
                                  a.linea,
                                  a.marca,
                                  a.familia,
                                  a.coleccion,
                                  a.ano,
                                  a.venta
                                )
                              }
                            >
                              <i class="fas fa-qrcode"></i>
                            </Button>

                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a.codigo,
                                  a.nombre,
                                  a.piezasPorCaja,
                                  a.costoUSD,
                                  a.costoMX,
                                  a.venta,
                                  a.utilidadP,
                                  a.utilidadM,
                                  a.lista1,
                                  a.lista2,
                                  a.lista3,
                                  a.lista4,
                                  a.observaciones,
                                  a.idLinea,
                                  a.idMarca,
                                  a.idFamilia,
                                  a.idColeccion,
                                  a.idProveedor,
                                  a.ano,
                                  a.EAN,
                                  a.RFID,
                                  a.precioEsp,
                                  a.codigoSAT,
                                  a.codigoUnidad,
                                  a._id
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) =>
                                jalaProporcion(
                                  a._id,
                                  a.codigo,
                                  a.nombre,
                                  a.tallas
                                )
                              }
                            >
                              <i class="fas fa-ruler"></i>
                            </Button>

                            <Baja
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={import.meta.env.VITE_URL_ARTICULOS}
                            />
                          </div>
                        ) : (
                          <div>
                            <Button color="info" id="Editar" size="sm" disabled>
                              <i class="far fa-edit"></i>
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>Ficha Tecnica</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {photoUrl ? (
              <h6 style={{ textAlign: "center" }}>
                <img src={photoUrl} alt="" />
              </h6>
            ) : photo ? (
              <h6 style={{ textAlign: "center" }}>
                <img src={photoUrl} alt="" />
              </h6>
            ) : null}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="xl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            Editar Modelo {codigo} / {nombre}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Numero de Modelo</Label>
              <Input
                type="text"
                placeholder="Codigo"
                value={codigo}
                required
                disabled
              />
            </Col>
            <Col md={3}>
              <Label>Nombre</Label>
              <Input
                type="text"
                placeholder="Nombre"
                value={nombre}
                required
                onChange={(e) => {
                  setNombre(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Piezas Por Caja</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Piezas Por Caja"
                value={piezasPorCaja}
                required
                onChange={(e) => {
                  setPiezasPorCaja(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Codigo de Barras (EAN)</Label>
              <Input
                type="text"
                placeholder="Codigo de Barras"
                value={EAN}
                required
                disabled
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>RFID</Label>
              <Input
                type="text"
                placeholder="RFID"
                value={RFID}
                disabled
              />
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Label>FOB USD</Label>
              <Input
                type="text"
                placeholder="FOB USD"
                value={costoUSD}
                required
                onChange={(e) => {
                  setCostoUSD(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Costo MX</Label>
              <Input
                type="text"
                placeholder="Costo MX"
                value={costoMX}
                required
                onChange={(e) => {
                  setCostoMX(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Utilidad %</Label>
              <Input
                type="number"
                placeholder="Utilidad %"
                value={utilidadP}
                required
                onChange={(e) => {
                  const value = parseFloat(e.target.value) || 0;
                  SetUtilidadP(value);
                  setLastChanged("utilidadP");
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Utilidad por monto </Label>
              <Input
                type="number"
                placeholder="Utilidad por monto"
                value={utilidadM}
                onChange={(e) => {
                  const value = parseFloat(e.target.value) || 0;
                  setUtilidadM(value);
                  setLastChanged("utilidadM");
                }}
              />
            </Col>

            <Col md={3}>
              <Label>Venta</Label>
              <Input
                type="text"
                placeholder="Venta"
                value={venta}
                required
                onChange={(e) => {
                  setVenta(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Observaciones</Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Codigo SAT</Label>
              <Input
                type="select"
                placeholder="CodigoSAT"
                value={codigoSAT}
                required
                onChange={(e) => {
                  setCodigoSAT(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="53101604">53101604 BLUSAS MUJER</option>
                <option value="53102002">53102002 VESTIDOS, FALDAS, JUMPER </option>
                <option value="53101504">53101504 PANTALONES MUJER</option>
                <option value="53101804">53101804 CHAMARRAS MUJER</option>
                <option value="53101704">53101704 SWEATER MUJER</option>
                <option value="53103100">53103100 CHALECOS</option>
                <option value="53102800">53102800 TRAJES DE BAÑO</option>
                <option value="53101602">53101602 CAMISAS HOMBRE</option>
                <option value="53101502">53101502 PANTALON HOMBRE</option>
                <option value="52121500">52121500 COBIJA</option>
                <option value="53101904">53101904 CONJUNTO</option>
                <option value="53102304">53102304 SILICON BRA</option>
                <option value="53102307">53102307 BODY TAPE</option>
                <option value="53102501">53102501 CINTO</option>
                <option value="53102502">53102502 BUFANDA/PAÑOLETA</option>
                <option value="53102503">53102503 SOMBRERO</option>
                <option value="53102516">53102516 GORRO/GORRA</option>
                <option value="53121601">53121601 BOLSO/CARTERA</option>
                <option value="53131633">53131633 PINZAS, BROCHES, PASADORES</option>
                <option value="54101602">54101602 COLLAR</option>
                <option value="53101601">53101601 PULSERA/BRAZALETE</option>
                <option value="54101604">54101604 ARETE</option>
                <option value="53101804">53101804 SACO</option>

              </Input>
            </Col>
            <Col md={3}>
              <Label>Codigo Unidad</Label>
              <Input
                type="string"
                placeholder="CodigoUnidad"
                value={codigoUnidad}
                required
                onChange={(e) => {
                  setCodigoUnidad(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Linea</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedLineaEdit}
                required
                onChange={(e) => {
                  setSelectedLineaEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Linea</option>
                {lineas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Marca</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedMarcaEdit}
                required
                onChange={(e) => {
                  setSelectedMarcaEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Marca</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Familia</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedFamiliaEdit}
                required
                onChange={(e) => {
                  setSelectedFamiliaEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Familia</option>
                {familias
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Coleccion</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedColeccionEdit}
                required
                onChange={(e) => {
                  setSelectedColeccionEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Coleccion</option>
                {colecciones
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Año</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={ano}
                required
                onChange={(e) => {
                  setAno(e.target.value);
                }}
              >
                <option value="0">Selecciona un Año</option>
                {years.map((a) => {
                  return <option value={a}>{a}</option>;
                })}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Proveedor</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedProveedorEdit}
                required
                onChange={(e) => {
                  setSelectedProveedorEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Proveedor</option>
                {proveedores
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Precio Especial</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={precioEsp}
                required
                onChange={(e) => {
                  setPrecioEsp(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>

          </Row>
          <Row>
            <Col md={6}>
              <Label>Foto</Label> 
              <Input
                type="file"
                onChange={(e) => {
                  setFile(e.target.files[0]);
                }}
              />
            </Col>
          </Row>
          <br />
          <h4>Precios de Venta</h4>
          <Row>
            <Col md={3}>
              <Label>Lista 1</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={lista1}
                required
                onChange={(e) => {
                  setLista1(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Lista 2</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={lista2}
                required
                onChange={(e) => {
                  setLista2(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Lista 3</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={lista3}
                required
                onChange={(e) => {
                  setLista3(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Lista 4</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={lista4}
                required
                onChange={(e) => {
                  setLista4(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editArticulos}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalProporcion} toggle={toggleProporcion}>
        <ModalHeader toggle={toggleProporcion}>
          <h4>
            Proporcion Modelo {codigo} / {nombre}
          </h4>
        </ModalHeader>
        <ModalBody>
          {/* Color and Size Selection Section */}
          <Row>
            <Col md={2}>
              <Label>Color</Label>
              <Input
                type="select"
                value={selectedColor}
                onChange={(e) => {
                  setSelectedColor(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {colores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .filter((color) => {
                    // Extract IDs from both existing color arrays
                    const existingColorIds = [
                      ...arrayColores.map((c) => c.id || c._id),
                      ...arrayColoresNew.map((c) => c.id || c._id),
                    ];
                    return !existingColorIds.includes(color._id);
                  })
                  .map((a) => {
                    return (
                      <option key={a._id} value={a._id}>
                        {a.name}
                      </option>
                    );
                  })}
              </Input>
            </Col>

            <Col md={1}>
              <Label>Agregar</Label>
              <br />
              <Button
                color="info"
                size="sm"
                onClick={() => {
                  addColor();
                }}
              >
                <i className="fas fa-plus"></i>
              </Button>
            </Col>

            <Col md={2}>
              <Label>Talla</Label>
              <Input
                type="select"
                value={selectedTalla}
                onChange={(e) => {
                  setSelectedTalla(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {tallas
                  .filter((talla) => {
                    // Extract IDs from both existing size arrays
                    const existingSizeIds = [
                      ...arrayTallas.map((t) => t.id || t._id),
                      ...arrayTallasNew.map((t) => t.id || t._id),
                    ];
                    return !existingSizeIds.includes(talla._id);
                  })
                  .map((a) => {
                    return (
                      <option key={a._id} value={a._id}>
                        {a.name}
                      </option>
                    );
                  })}
              </Input>
            </Col>

            <Col md={1}>
              <Label>Agregar</Label>
              <br />
              <Button
                color="info"
                size="sm"
                onClick={() => {
                  addTalla();
                }}
              >
                <i className="fas fa-plus"></i>
              </Button>
            </Col>
          </Row>

          {/* Combined Proportion and Barcode Table */}
          <Row className="w-100 mt-4">
            <div className="bg-gray-50 p-6 rounded-lg w-100">
              <Label className="text-gray-700 font-medium mb-3 block">
                Proporción y Códigos de Barras
              </Label>
              <div
                className="overflow-x-auto"
                style={{
                  overflowX: "auto",
                  WebkitOverflowScrolling: "touch",
                  width: "100%",
                  display: "block",
                }}
              >
                <Table
                  className="border-collapse"
                  style={{ width: "max-content" }}
                >
                  <thead>
                    <tr className="border-b border-gray-200">
                      <th className="py-3 w-24 text-left font-normal sticky left-0 bg-gray-50 z-10"></th>
                      {/* Size headers */}
                      {[
                        ...arrayTallas.sort((a, b) => {
                          const indexA = customSizeOrder.indexOf(a.name);
                          const indexB = customSizeOrder.indexOf(b.name);
                          if (indexA === -1 && indexB === -1) return 0;
                          if (indexA === -1) return 1;
                          if (indexB === -1) return -1;
                          return indexA - indexB;
                        }),
                        ...arrayTallasNew.sort((a, b) => {
                          const indexA = customSizeOrder.indexOf(a.name);
                          const indexB = customSizeOrder.indexOf(b.name);
                          if (indexA === -1 && indexB === -1) return 0;
                          if (indexA === -1) return 1;
                          if (indexB === -1) return -1;
                          return indexA - indexB;
                        }),
                      ].map((size) => (
                        <th
                          key={size.id}
                          className="py-2 px-2 text-center font-medium text-gray-600 border-l border-gray-300"
                          style={{ minWidth: "140px" }}
                        >
                          <div className="text-sm font-semibold mb-2">
                            {size.name}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {/* Original colors rows */}
                    {arrayColores.map((color) => (
                      <tr key={color.id} className="border-b border-gray-200">
                        <td className="py-3 pr-4 text-gray-600 font-medium uppercase sticky left-0 bg-gray-50 z-10">
                          {color.name}
                        </td>
                        {/* Size cells for original colors */}
                        {[
                          ...arrayTallas.sort((a, b) => {
                            const indexA = customSizeOrder.indexOf(a.name);
                            const indexB = customSizeOrder.indexOf(b.name);
                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return 1;
                            if (indexB === -1) return -1;
                            return indexA - indexB;
                          }),
                          ...arrayTallasNew.sort((a, b) => {
                            const indexA = customSizeOrder.indexOf(a.name);
                            const indexB = customSizeOrder.indexOf(b.name);
                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return 1;
                            if (indexB === -1) return -1;
                            return indexA - indexB;
                          }),
                        ].map((size) => {
                          const isOriginalSize = arrayTallas.some(s => s.id === size.id);

                          return (
                            <td
                              key={size.id}
                              className="py-2 px-2 border-l border-gray-300"
                            >
                              <div className="space-y-2">
                                {/* Quantity Input */}
                                <input
                                  type="number"
                                  value={getEntryValue(color.id, size.id, 'amount')}
                                  onChange={(e) => {
                                    handleUnifiedInputChange(size.id, color.id, e.target.value, 'amount');
                                  }}
                                  min="0"
                                  className="w-full border border-gray-300 rounded-md p-1 text-center text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                                  placeholder="0"
                                />
                                {/* Barcode Input */}
                                <input
                                  type="text"
                                  value={getEntryValue(color.id, size.id, 'EAN')}
                                  onChange={(e) => {
                                    handleUnifiedInputChange(size.id, color.id, e.target.value, 'EAN');
                                  }}
                                  className="w-full border border-gray-300 rounded-md p-1 text-center text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                                  placeholder="Código de barras"
                                />
                              </div>
                            </td>
                          );
                        })}
                      </tr>
                    ))}

                    {/* New colors rows */}
                    {arrayColoresNew.map((color) => (
                      <tr key={color.id} className="border-b border-gray-200">
                        <td className="py-3 pr-4 text-gray-600 font-medium uppercase sticky left-0 bg-gray-50 z-10">
                          {color.name}
                        </td>
                        {/* Size cells for new colors */}
                        {[
                          ...arrayTallas.sort((a, b) => {
                            const indexA = customSizeOrder.indexOf(a.name);
                            const indexB = customSizeOrder.indexOf(b.name);
                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return 1;
                            if (indexB === -1) return -1;
                            return indexA - indexB;
                          }),
                          ...arrayTallasNew.sort((a, b) => {
                            const indexA = customSizeOrder.indexOf(a.name);
                            const indexB = customSizeOrder.indexOf(b.name);
                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return 1;
                            if (indexB === -1) return -1;
                            return indexA - indexB;
                          }),
                        ].map((size) => {
                          return (
                            <td
                              key={size.id}
                              className="py-2 px-2 border-l border-gray-300"
                            >
                              <div className="space-y-2">
                                {/* Quantity Input */}
                                <input
                                  type="number"
                                  value={getEntryValue(color.id, size.id, 'amount')}
                                  onChange={(e) => {
                                    handleInputChangeNew(size.id, color.id, e.target.value, 'amount');
                                  }}
                                  min="0"
                                  className="w-full border border-gray-300 rounded-md p-1 text-center text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                                  placeholder="0"
                                />
                                {/* Barcode Input */}
                                <input
                                  type="text"
                                  value={getEntryValue(color.id, size.id, 'EAN')}
                                  onChange={(e) => {
                                    handleInputChangeNew(size.id, color.id, e.target.value, 'EAN');
                                  }}
                                  className="w-full border border-gray-300 rounded-md p-1 text-center text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                                  placeholder="Código de barras"
                                />
                              </div>
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editProporcion}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoArticulos;
